import { BrowseByTagsType } from 'common/events/ClientEvents';
import React from 'react';
import { CategoryPageContent } from 'src/gqlReactTypings.generated.d';
import { DishFirstExploreWidthLimit } from 'src/pages/consumer/dish-first/explore/components/SharedStyles';
import {
  SegmentHeader,
  SegmentHeaderContainer,
  SegmentHeaderRow,
  SegmentHeaderTitle,
} from 'src/pages/consumer/dish-first/explore/styles';
import { CategoryCard } from 'src/shared/design-system/CategoryCard/CategoryCard';
import { generateThumborImgUrl } from 'src/shared/design-system/DynamicImage';
import { minScreen } from 'src/shared/utils/StyledComponentUtils';
import styled, { css } from 'styled-components';
import { Mixins, ScreenWidth, ScreenWidthValues, Spacing } from 'web-common/src/shared/styles';
import { Category } from './types';

export const BackgroundContainer = styled.div<{ url?: string; tabletUrl?: string; desktopUrl?: string }>`
  width: 100%;

  ${({ url }) =>
    url
      ? css`
          padding-top: ${Spacing.DOUBLE};
          background: url(${generateThumborImgUrl({
              src: url,
              width: ScreenWidthValues[ScreenWidth.SMALL],
            })})
            center / cover no-repeat;
        `
      : ''}
  ${minScreen(ScreenWidth.SMALL)} {
    ${({ url, tabletUrl }) =>
      url || tabletUrl
        ? css`
            padding-top: ${Spacing.DOUBLE};
            background: url(${generateThumborImgUrl({
                src: tabletUrl ?? url ?? '',
                width: ScreenWidthValues[ScreenWidth.LARGE],
              })})
              center / cover no-repeat;
          `
        : ''}
  }

  ${minScreen(ScreenWidth.LARGE)} {
    ${({ url, desktopUrl }) =>
      url || desktopUrl
        ? css`
            padding-top: ${Spacing.DOUBLE};
            background: url(${generateThumborImgUrl({
                src: desktopUrl ?? url ?? '',
                width: ScreenWidthValues[ScreenWidth.EXTRA_LARGE],
              })})
              center / cover no-repeat;
          `
        : ''}
  }
`;

const imageWidthHeight = {
  width: 684,
  height: 480,
};

const BrowseByCategoriesContainer = styled(DishFirstExploreWidthLimit)`
  margin-top: ${Spacing.NONE};
  margin-bottom: ${Spacing.DOUBLE_HALF};
`;

const ExploreCategoryCard = styled.div`
  display: flex;
  flex-direction: row;
  // width: 171px;
`;

const CardsContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`;

const CardsRow = styled.div`
  grid-template-columns: 1fr 1fr 1fr 1fr;

  display: grid;
  gap: ${Spacing.SINGLE};
  padding: ${Spacing.SINGLE};
  width: 100%;

  -ms-overflow-style: none;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    -webkit-appearance: none;
    display: none;
  }

  scroll-snap-type: x mandatory;
  & > * {
    scroll-snap-align: start;
  }

  ${Mixins.Media.maxWidthMedium(css`
    grid-template-columns: 1fr 1fr 1fr;
    scroll-snap-type: none;
  `)}

  ${Mixins.Media.maxWidthSmall(css`
    grid-template-columns: 1fr 1fr;
    scroll-snap-type: none;
  `)}

 & > * {
    opacity: 1;
    transition: opacity 0.11s ease-in-out;
  }
  .offscreen {
    opacity: 0;
  }
`;

interface BrowseByCategoriesProps {
  title: string;
  categories: Category[];
  categoryPageContent?: CategoryPageContent | null;
  onClick: (value: string, position: number, tagType: BrowseByTagsType) => void;
}

export const Segment: React.FC<BrowseByCategoriesProps> = ({ title, categories, categoryPageContent, onClick }) => (
  <BackgroundContainer
    url={categoryPageContent?.moreCuisinesBackgroundUrl ?? undefined}
    tabletUrl={categoryPageContent?.moreCuisinesBackgroundUrlTablet ?? undefined}
    desktopUrl={categoryPageContent?.moreCuisinesBackgroundUrlDesktop ?? undefined}>
    <BrowseByCategoriesContainer>
      <SegmentHeaderContainer>
        <SegmentHeaderRow>
          <SegmentHeader>
            <SegmentHeaderTitle>{title}</SegmentHeaderTitle>
          </SegmentHeader>
        </SegmentHeaderRow>
      </SegmentHeaderContainer>
      <CardsContainer>
        <CardsRow>
          {categories.map((p, i) => {
            const buttonProps = { ...p };
            return (
              <ExploreCategoryCard key={p.value}>
                <CategoryCard
                  sourceWidth={imageWidthHeight.width}
                  sourceHeight={imageWidthHeight.height}
                  onClick={() => onClick(p.value, i, p.tagType)}
                  {...buttonProps}
                />
              </ExploreCategoryCard>
            );
          })}
        </CardsRow>
      </CardsContainer>
    </BrowseByCategoriesContainer>
  </BackgroundContainer>
);
